/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery,
  type DataTag,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type { Error, MoveOutTimeline } from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Returns the state of each step of the move-out timeline (move out initiated through to closure complete). The top-level status gives the overall state of the move-out; when it is NOT_MOVING_OUT the timeline should not be shown. Step keys and statuses are owned by be-customers and passed through as strings.
 * @summary Retrieve the move-out timeline for an account
 */
export const getMoveOutTimeline = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<MoveOutTimeline>(
    {
      url: `/api/v1/accounts/${accountId}/moveOut/timeline`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetMoveOutTimelineQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "moveOut", "timeline"] as const
}

export const useGetMoveOutTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof getMoveOutTimeline>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMoveOutTimeline>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetMoveOutTimelineQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMoveOutTimeline>>
  > = ({ signal }) => getMoveOutTimeline(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getMoveOutTimeline>>,
    TError,
    TData
  >
}

export type GetMoveOutTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMoveOutTimeline>>
>
export type GetMoveOutTimelineQueryError = ErrorType<Error>

/**
 * @summary Retrieve the move-out timeline for an account
 */

export function useGetMoveOutTimeline<
  TData = Awaited<ReturnType<typeof getMoveOutTimeline>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMoveOutTimeline>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetMoveOutTimelineQueryOptions(accountId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}
